import React from 'react';
import { motion } from 'framer-motion';
import Button from '../Button/Button';
import styles from './CtaBanner.module.css';

/**
 * CtaBanner   dark rounded CTA strip with optional primary + secondary buttons.
 * Used on AI Features, Our Story, Platform Overview pages.
 */
const CtaBanner = ({
  title,
  subtitle,
  primaryLabel,
  primaryHref,
  secondaryLabel,
  secondaryHref,
  variant = 'dark', // 'dark' | 'deep-blue'
}) => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-100px' }}
      transition={{ duration: 0.6 }}
      className={`${styles.banner} ${styles[variant]}`}
    >
      <div className={styles.inner}>
        <h3 className={styles.title}>{title}</h3>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        <div className={styles.actions}>
          {primaryLabel && (
            <Button
              as="a"
              href={primaryHref || '/#'}
              variant={variant === 'deep-blue' ? 'gradient' : 'primary'}
              size="md"
            >
              {primaryLabel}
            </Button>
          )}
          {secondaryLabel && (
            <Button
              as="a"
              href={secondaryHref || '/#'}
              variant={variant === 'deep-blue' ? 'secondary' : 'secondary'}
              size="md"
            >
              {secondaryLabel}
            </Button>
          )}
        </div>
      </div>
    </motion.section>
  );
};

export default CtaBanner;
